import { addAndTrack } from "../../../calculators/helpers";
import { getFinalTlLv, round1, round3 } from "../../../helpers";
import { Green, Red } from "../../../styledCpns/DataDisplay";
import { CaStamina, lightPAs_Catalyst } from "../config";
import {
  checkAscs,
  checkCharMC,
  checkCons,
  makeTlBnes,
  xtraTlLv
} from "../helpers";
import tlLvMults from "../tlLvMults";

const isInfusedHydroES = (charBCs) =>
  charBCs.find(({ index }) => index === 1)?.inputs?.includes("Hydro");

function getESBuffValue(char, partyData) {
  const level = getFinalTlLv(char, Wanderer.actvTalents[1], partyData);
  return [
    round1(32.98 * tlLvMults[5][level]),
    round1(26.39 * tlLvMults[5][level])
  ];
}

const Wanderer = {
  code: 63,
  name: "Wanderer",
  icon: "f/f8/Wanderer_Icon",
  sideIcon: "5/54/Character_Wanderer_Side_Icon",
  rarity: 5,
  nation: "Sumeru",
  vision: "Anemo",
  weapon: "Catalyst",
  stats: [
    { "Base HP": 791, "Base ATK": 26, "Base DEF": 47 },
    { "Base HP": 2053, "Base ATK": 66, "Base DEF": 123 },
    { "Base HP": 2731, "Base ATK": 88, "Base DEF": 163 },
    { "Base HP": 4086, "Base ATK": 131, "Base DEF": 244 },
    {
      "Base HP": 4568,
      "Base ATK": 147,
      "Base DEF": 273,
      "CRIT Rate": 4.8
    },
    {
      "Base HP": 5256,
      "Base ATK": 169,
      "Base DEF": 313,
      "CRIT Rate": 4.8
    },
    {
      "Base HP": 5899,
      "Base ATK": 190,
      "Base DEF": 352,
      "CRIT Rate": 9.6
    },
    {
      "Base HP": 6593,
      "Base ATK": 213,
      "Base DEF": 394,
      "CRIT Rate": 9.6
    },
    {
      "Base HP": 7076,
      "Base ATK": 228,
      "Base DEF": 423,
      "CRIT Rate": 9.6
    },
    {
      "Base HP": 7777,
      "Base ATK": 251,
      "Base DEF": 465,
      "CRIT Rate": 9.6
    },
    {
      "Base HP": 8259,
      "Base ATK": 266,
      "Base DEF": 493,
      "CRIT Rate": 14.4
    },
    {
      "Base HP": 8968,
      "Base ATK": 289,
      "Base DEF": 536,
      "CRIT Rate": 14.4
    },
    {
      "Base HP": 9450,
      "Base ATK": 305,
      "Base DEF": 564,
      "CRIT Rate": 19.2
    },
    {
      "Base HP": 10164,
      "Base ATK": 328,
      "Base DEF": 607,
      "CRIT Rate": 19.2
    }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Yuuban Meigen",
      desc: [],
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Elemental"],
          baseMult: 68.71,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Elemental"],
          baseMult: 65.02,
          multType: 1
        },
        {
          name: "3-Hit (1/2)",
          dmgTypes: ["NA", "Elemental"],
          baseMult: 47.64,
          multType: 1
        },
        {
          name: "Charged Attack",
          dmgTypes: ["CA", "Elemental"],
          baseMult: 132.08,
          multType: 2
        },
        CaStamina[50],
        ...lightPAs_Catalyst,
        {
          name: "Wind Arrow DMG (A4) (1/4)",
          dmgTypes: [null, "Elemental"],
          baseMult: 0,
          multType: 2,
          conditional: true,
          getTlBnes: ({ char, selfMCs }) => {
            if (checkAscs[4](char)) {
              const ESisOn = checkCharMC(Wanderer.buffs, char, selfMCs.BCs, 0);
              const bnValue = ESisOn && checkCons[1](char) ? 60 : 35;
              return makeTlBnes(true, "mult", [1, 4], bnValue);
            }
          }
        }
      ]
    },
    {
      type: "Elemental Skill",
      name: "Hanega: Song of the Wind",
      image: "b/b0/Talent_Hanega_Song_of_the_Wind",
      desc: [],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 95.2,
          multType: 2
        }
      ],
      otherStats: () => [{ name: "CD", value: "6s" }]
    },
    {
      type: "Elemental Burst",
      name: "Kyougen: Five Ceremonial Plays",
      image: "6/64/Talent_Kyougen_Five_Ceremonial_Plays",
      desc: [],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Fudou Style Vacuum Slugger DMG (1/5)",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 147.2,
          multType: 2
        }
      ],
      otherStats: () => [{ name: "CD", value: "15s" }],
      energyCost: 60
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Jade-Claimed Flower",
      image: "9/95/Talent_Jade-Claimed_Flower",
      desc: (
        <>
          If Hanega: Fushi Kakka comes into contact with
          Hydro/Pyro/Cryo/Electro, this instance of the Windfavored state will
          obtain buffs according to the contacted element:
          <br />• Hydro: Sky-Dweller Point cap increases by 20.
          <br />• Pyro: ATK increases by 30%.
          <br />• Cryo: CRIT Rate increases by 20%.
          <br />• Electro: When Normal and Charged Attacks hit opponents, 0.8
          Energy will be restored. Energy can be restored in this manner every
          0.2s.
          <br />
          You can have 2 different kinds of these buffs simultaneously.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "Gales of Reverie",
      image: "4/4f/Talent_Gales_of_Reverie",
      desc: (
        <>
          When The Wanderer hits opponents with Normal and Charged Attacks in
          his Windfavored state, he has a 16% chance to obtain the Descent
          effect: The next time The Wanderer sprints while in this instance of
          the Windfavored state, this effect will be removed, this sprint
          instance will not consume any Sky-Dweller Points, and he will fire off
          4 wind arrows that deal 35% of his ATK as Anemo DMG each.
          <br />
          For each Normal and Charged Attack that does not produce this effect,
          the next attack of those kinds will have a 12% increase chance of
          producing it. The calculation of the effect production is done once
          every 0.1s.
        </>
      )
    },
    {
      type: "Passive",
      name: "Strum the Swirling Winds",
      image: "8/85/Talent_Strum_the_Swirling_Winds",
      desc: (
        <>
          Mora expended when ascending Bows and Catalysts is decreased by 50%.
        </>
      )
    }
  ],
  constellation: [
    {
      name: "Shoban: Ostentatious Plumage",
      image: "c/c9/Constellation_Shoban_Ostentatious_Plumage",
      desc: (
        <>
          When in the Windfavored State, The Wanderer’s Normal and Charged
          Attack SPD is increased by 10%.
          <br />
          Additionally, the wind arrows fired by the Passive Talent “Gales of
          Reverie” will deal 25% additional ATK as DMG. You must unlock the
          Passive Talent “Gales of Reverie” first.
        </>
      )
    },
    {
      name: "Niban: Moonlit Isle Amidst White Waves",
      image: "4/4a/Constellation_Niban_Moonlit_Isle_Amidst_White_Waves",
      desc: (
        <>
          When in the Windfavored State, the Kyougen: Shikiraku Gobandate skill
          will see its DMG increased by 4% per point of difference between the
          max amount of Sky-Dweller Points contrasted with Sky-Dweller’s present
          capacity when using this skill.
          <br />
          Through this method, you can increase Kyougen: Shikiraku Gobandate’s
          DMG by a maximum of 200%.
        </>
      )
    },
    {
      name: "Sanban: Moonflower Kusemai",
      image: "c/c0/Constellation_Sanban_Moonflower_Kusemai",
      desc: "Hanega: Song of the Wind"
    },
    {
      name: "Yonban: Set Adrift into Spring",
      image: "7/77/Constellation_Yonban_Set_Adrift_into_Spring",
      desc: (
        <>
          When casting Hanega: Fushi Kakka, should the Passive Talent
          “Jade-Claimed Flower” be triggered, the character will gain
          enhancement effects in correspondence to the contacted Elemental
          Type(s), and also gain a random untriggered enhancement effect.
        </>
      )
    },
    {
      name: "Matsuban: Ancient Illuminator From Abroad",
      image: "8/85/Constellation_Matsuban_Ancient_Illuminator_From_Abroad",
      desc: "Kyougen: Five Ceremonial Plays"
    },
    {
      name: "Shugen: The Curtains' Melancholic Sway",
      image: "0/01/Constellation_Shugen_The_Curtains%27_Melancholic_Sway",
      desc: (
        <>
          When The Wanderer actively hits opponents with Normal Attacks while in
          the Windfavored state, the following effects will occur:
          <br />• Deals an instance of 40% ATK as Anemo DMG. This DMG will be
          considered Normal Attack DMG.
          <br />• Restores 4 Sky-Dweller Points to The Wanderer. Sky-Dweller
          Points can be restored in this manner once every 0.2s. This
          restoration can occur 5 times within one Windfavored duration.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Elemental Skill",
      desc: ({ char, partyData }) => {
        const [naBonus, caBonus] = getESBuffValue(char, partyData) || [];
        return (
          <>
            Increases <Green>Normal Attack DMG</Green> by{" "}
            <Green b>{1 + round3(naBonus / 100)}</Green> times and{" "}
            <Green>Charged Attack DMG</Green> by{" "}
            <Green b>{1 + round3(caBonus / 100)}</Green> times.
            <br /> At C1, increases <Green>
              Normal and Charged Attack SPD
            </Green>{" "}
            by <Green b>10%</Green>, increases <Green>Wind Arrow DMG</Green>{" "}
            (A4) by <Green b>25%</Green> of <Green>ATK</Green>.
          </>
        );
      },
      isGranted: () => true,
      affect: "self",
      addBnes: ({ ATTRs, hitBnes, char, partyData, tkDesc, tracker }) => {
        const bnValues = getESBuffValue(char, partyData);
        const fields = ["NA.sMult", "CA.sMult"];
        addAndTrack(tkDesc, hitBnes, fields, bnValues, tracker);

        if (checkCons[1](char)) {
          const fields = ["Normal ATK SPD", "Charged ATK SPD"];
          addAndTrack(tkDesc, ATTRs, fields, 10, tracker);
        }
      }
    },
    {
      index: 1,
      src: "Ascension 1 Passive",
      desc: () => (
        <>
          If Hanega: Fushi Kakka (ES) comes into contact with
          Hydro/Pyro/Cryo/Electro, the Windfavored state will obtain buffs:
          <br />• Hydro: <Green>Sky-Dweller Point cap</Green> increases by{" "}
          <Green b>20</Green>.
          <br />• Pyro: <Green>ATK</Green> increases by <Green b>30%</Green>.
          <br />• Cryo: <Green>CRIT Rate</Green> increases by{" "}
          <Green b>20%</Green>.
        </>
      ),
      isGranted: checkAscs[1],
      affect: "self",
      inputTypes: ["scara", "scara", "scara"],
      inputs: ["Pyro", "Pyro", "Pyro"],
      selfLabels: [
        "Infused element 1",
        "Infused element 2",
        "Random infused element (C4)"
      ],
      addBnes: ({ ATTRs, inputs = [], tkDesc, tracker }) => {
        if (inputs.includes("Pyro")) {
          addAndTrack(tkDesc, ATTRs, "ATK%", 30, tracker);
        }
        if (inputs.includes("Cryo")) {
          addAndTrack(tkDesc, ATTRs, "CRIT Rate", 20, tracker);
        }
      }
    },
    {
      index: 2,
      src: "Constellation 2",
      desc: ({ charBCs }) => {
        return (
          <>
            When in Windfavored State (ES), Kyougen: Shikiraku Gobandate{" "}
            <Green>(EB) DMG</Green> is increased by <Green b>4%</Green> per
            point of difference between the max amount of Sky-Dweller Points
            (SDP) contrasted with Sky-Dweller’s present capacity. Maximum 200%.{" "}
            <Red>SDP cap: {isInfusedHydroES(charBCs) ? 120 : 100}.</Red>
          </>
        );
      },
      isGranted: checkCons[2],
      affect: "self",
      selfLabels: ["Current SDP"],
      inputs: [0],
      inputTypes: ["text"],
      maxs: [120],
      addBnes: ({ hitBnes, inputs, charBCs, tkDesc, tracker }) => {
        const SDPdifference =
          (isInfusedHydroES(charBCs) ? 120 : 100) - (inputs?.[0] || 0);
        const bnValue = Math.min(Math.max(SDPdifference, 0) * 4, 200);
        addAndTrack(tkDesc, hitBnes, "EB.pct", bnValue, tracker);
      }
    }
  ]
};

export default Wanderer;
